import { type IHttpApi } from '@cian/http-api';
import { type ILogger } from '@cian/logger';

import { type TLkType } from '@/app/shared/types/lkType';

import { ResponseError } from '@/packages/errors';

import { type TGetLkTypeResponse, fetchGetLkType } from '@/repositories/generated/shared/lk-type/v2/get-lk-type';

interface IApplicationContext {
  logger: ILogger;
  httpApi: IHttpApi;
}

export async function fetchUserLkType({ httpApi }: IApplicationContext): Promise<TLkType> {
  const userLkTypeData: TGetLkTypeResponse = await fetchGetLkType({ httpApi });

  if (userLkTypeData.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchUserLkType',
      message: userLkTypeData.response.message || '',
      details: {
        error: JSON.stringify(userLkTypeData.response.errors),
      },
    });
  }

  return userLkTypeData.response.lkType;
}

export async function fetchUserLkTypeSafe(context: IApplicationContext): Promise<TLkType | null> {
  try {
    return await fetchUserLkType(context);
  } catch (ex) {
    const { logger } = context;

    logger.warning(ex, { degradation: 'Информация о типе ЛК пользователя' });

    return null;
  }
}
